
import { EvolucionInventarioProps } from '../../../containers/pages/Dashboard';
import {
  DEPRECIACION_DASHBOARD_REQUEST,
  DEPRECIACION_DASHBOARD_SUCCESS,
  DEPRECIACION_DASHBOARD_FAIL
} from '../../actions/Dashboard/types';

// Define el tipo para el estado inicial
interface DatosInventarioState {
  depreciacionInventario: EvolucionInventarioProps[];
}
// Estado inicial tipado
const initialState: DatosInventarioState = {
  depreciacionInventario: [],
};

// Reducer con tipos definidos
const depreciacionInventarioReducers = (state = initialState, action: any) => {
  switch (action.type) {
    case DEPRECIACION_DASHBOARD_REQUEST:
      return { ...state, loading: true };
    case DEPRECIACION_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        depreciacionInventario: action.payload,
      };
    case DEPRECIACION_DASHBOARD_FAIL:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};



export default depreciacionInventarioReducers;
